import React from 'react';
import { CheckCircle, XCircle, X, Download } from 'lucide-react';

export default function BulkActionBar({ selectedCount, onApprove, onReject, onClear, onBulkExport }) {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-indigo-500 shadow-2xl z-50">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Selection Info */}
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center">
                <span className="text-sm font-bold text-indigo-600">{selectedCount}</span>
              </div>
              <span className="text-sm font-medium text-gray-700">
                {selectedCount} proposal{selectedCount !== 1 ? 's' : ''} selected
              </span>
            </div>
            
            {/* Clear Selection */}
            <button
              onClick={onClear}
              className="text-sm text-gray-500 hover:text-gray-700 transition-colors flex items-center gap-1"
            >
              <X className="w-4 h-4" />
              Clear
            </button>
          </div>

          {/* Action Buttons */}
          <div className="flex items-center gap-3">
            {/* Bulk Export Button */}
            {onBulkExport && (
              <button
                onClick={onBulkExport}
                className="flex items-center gap-2 px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-all shadow-md hover:shadow-lg transform hover:scale-105"
                title="Export selected proposals as PDFs"
              >
                <Download className="w-5 h-5" />
                Export {selectedCount > 1 ? 'All' : ''}
              </button>
            )}
            
            {/* Approve Button */}
            <button
              onClick={onApprove}
              className="flex items-center gap-2 px-6 py-2.5 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg transition-all shadow-md hover:shadow-lg transform hover:scale-105"
            >
              <CheckCircle className="w-5 h-5" />
              Approve {selectedCount > 1 ? 'All' : ''}
            </button>

            {/* Reject Button */}
            <button
              onClick={onReject}
              className="flex items-center gap-2 px-6 py-2.5 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg transition-all shadow-md hover:shadow-lg transform hover:scale-105"
            >
              <XCircle className="w-5 h-5" />
              Reject {selectedCount > 1 ? 'All' : ''}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
